import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-job-titles',
  templateUrl: './job-titles.component.html',
  styleUrls: ['./job-titles.component.scss'],
      encapsulation: ViewEncapsulation.None
})
export class JobTitlesComponent implements OnInit {

   public JobTitles: any[] = [];
 public messages: any = {};

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,        private toastr : ToastrService,
      public  translate: TranslateService
  ) {} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;

  public tempData = [];

  @ViewChild(DatatableComponent) table: DatatableComponent;

  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;v

  ngOnInit(): void {
    this.apisService.getJobTitles().subscribe({ 
      next:(response:any)=> { 
        this.JobTitles = response || [] ;
        console.log('response is' , this.JobTitles)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    }) 
 
     this.setDatatableMessages(); // set initial messages

    // listen for language change dynamically
    this.translate.onLangChange.subscribe(() => {
      this.setDatatableMessages();
    });

  }

   private setDatatableMessages() {
    this.messages = {
      totalMessage: this.translate.instant('MENU.DASHBOARD.total')
    };
  }

  getTags(){ 
  this.apisService.getJobTitles().subscribe({
    next: (response: any) => {
      // The actual array is in response.data.data
        this.JobTitles = response || [] ;

      this.totalItems = this.JobTitles.length;
      console.log("employee:", this.JobTitles);
    },
    error: (error: any) => {
      console.log(error);
    }
  }
    
  )
 }
 
 
 /*----------  Handling image Error  ----------*/
 onImageError(event) {
  event.target.src = 'assets/images/logo/12.png';
 }
  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  

 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.JobTitles = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }
confirmDelete(id: any) {
  Swal.fire({
    title: this.translate.instant('MENU.DASHBOARD.CONFIRM_DELETE_TITLE'),
    text: this.translate.instant('MENU.DASHBOARD.CONFIRM_DELETE_TEXT'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this.translate.instant('MENU.DASHBOARD.YES_DELETE'),
    cancelButtonText: this.translate.instant('MENU.DASHBOARD.CANCEL')
  }).then((result) => {
    if (result.isConfirmed) {
      this.deleteJobTitle(id);
    }
  });
}

  
   /*----------  deleting products  ----------*/
 deleteJobTitle(id:any){ 
  console.log(id ,' delete id');
  this.apisService.DeleteJobTitles(id).subscribe({
    next: (response: any) => {
   this.toastr.success(
        this.translate.instant('MENU.DASHBOARD.DELETED_SUCCESSFULLY')
      );       this.getTags();
    },
    error: (error: any) => {
      console.log(error);
   this.toastr.error(
        this.translate.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
      );    }
  }
    
  )
 } 

editJobTitle(productId: number) {
  this.router.navigate(['/job-title', productId]);
}
}
